import { h } from "preact";
import classname from "../../foundation/utils/classname";
import ColorName from "./ColorName";
import ColorDotSize from "./ColorDotSize";

import "./style.css";

interface Props {
    class?: string;
    size?: ColorDotSize;
    color: ColorName;
    selected?: boolean;
    mainColor?: boolean;
    onClick?: (ev: MouseEvent, color: ColorName) => void;
}

const ColorDot = ({
    class: cssClass,
    size = "small",
    color = "karl",
    selected,
    mainColor,
    onClick
}: Props) => {
    const handleClick = (ev: MouseEvent) => {
        onClick?.(ev, color!);
    };

    return (
        <div class={classname("colorDot", cssClass, size, color, { selected, mainColor, clickable: !!onClick })} onClick={handleClick}/>
    );
};

export default ColorDot;
